import { extendDateType } from '@utils/dateUtils'

import { extendNumberType } from './numberUtils'

let doneExtensions = false

export function extendNativeTypes() {
  if (doneExtensions) return

  extendNumberType()
  extendDateType()

  doneExtensions = true
}
